import axios from 'axios'
import { errorHandler } from '../exports/error_management'

// import { StorageCache } from '../exports/dataStorage'

// const storageKey = 'ams-order-notification-key'
const api = async (method, path, params) => axios[method](path, params)
const state = {
    item: null,
    toggle: null,
    count: null,
    items: [],
}

const mutations = {
    set_item(state, payload) {
        state.item = payload
    },
    set_count(state, payload) {
        state.count = payload
    },
    set_items(state, payload) {
        state.items = payload
    },
    set_toggle(state, payload) {
        state.toggle = payload
    },
}

const actions = {
    async fetchAll(context) {
        try {
            const results = await api('get', `notification`)
            const Notifications=results.data.success?.data
            let userSessionNotificaitons= JSON.parse(sessionStorage.getItem("notifications"));
        //   console.log("thh",results.data.success.data?.count)
            if(userSessionNotificaitons && Notifications?.count !== 0 ){
                // merge new notification with existing ones
                Notifications?.data.forEach(notification => {
                    userSessionNotificaitons?.data.push(notification);
                    userSessionNotificaitons.count =+ 1;
                });

                 sessionStorage.setItem("notifications",JSON.stringify(userSessionNotificaitons));

            }else if(!userSessionNotificaitons && Notifications?.count!==0){
                userSessionNotificaitons = Notifications
                sessionStorage.setItem("notifications",JSON.stringify( userSessionNotificaitons));
            }
            // console.log("waht the hell",userSessionNotificaitons?.data.count);
            context.commit('set_items',userSessionNotificaitons ?? {count:0,data:{}} );
            context.commit('set_count', userSessionNotificaitons?.count ?? 0);
          
        } catch (err) {
            errorHandler(err)
        }
    },
    async updateCount(context) {
        await api('put', `notification/updatecount`)
        context.commit('set_count', 0)
    },

    async toggleNotification(context, payload) {
        const results = await api(
            'put',
            `notification/${payload.user_id}/toggle-notification`,
            payload
        )
        console.log('resultssss', results.data.success.data.notification)
        context.commit('set_toggle', results.data.success.data.notification)
    },
    async checkNotificationToggle(context, payload) {
        try {

            const results = await api(
                'get',
                `notification/checknotifition-toggle/${payload.user_id}`
            )
            context.commit('set_toggle', results.data.success.data.notification)
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {
    
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
